module.exports = __webpack_public_path__ + "img/ExpirySyncDateToggle.f9e2a847.png";